$(document).ready(function() {

    $(document).foundation();

    $(window).on(
        'hide.zf.dropdownmenu ' +
        'show.zf.dropdownmenu ' +
        'show.zf.dropdown ' +
        'hide.zf.dropdown ' +
        'open.zf.drilldown ' +
        'hide.zf.drilldown ' +
        'closed.zf.dilldown ' +
        'show.zf.tooltip ' +
        'hide.zf.tooltip ' +
        'off.zf.toggler ' +
        'on.zf.toggler',
        function (e) {
            e.preventDefault();
        }
    );

    var accordionNav = $('#accordion-nav');


    function initResize(newSize, oldSize) {

        if( newSize != 'small') {
            if( accordionNav.data().zfPlugin ) {
                accordionNav.foundation('destroy');
            }
        } else {
            new Foundation.Accordion(accordionNav);
        }

    }


    $(window).on('changed.zf.mediaquery', function (event, newSize, oldSize) {
        Foundation.util.throttle(initResize(newSize, oldSize), 300);
    });

    $(window).load(function(){
        if( Foundation.MediaQuery.current == 'small') {
            new Foundation.Accordion(accordionNav);
        }

    });

    initResize();

    // Mobile Search
    $( ".mobile-header-search" ).on( "click", function() {

        if ( $(this).hasClass("slideDown") ) {

            // Hide the search container
            $('.search-container').slideUp();
            $('.search-container').find('.exp-search-input').trigger( "blur" );
            $(this).removeClass("slideDown");
            console.log('removed');

        } else {

            // Show the search container
            $('.search-container').slideDown();
            $('.search-container').find('.exp-search-input').trigger( "focus" );
            $(this).addClass("slideDown");
            console.log('added');

        }

    });



    // Submit search on mobile
    $('.mobile-search-icon img').on("click touchstart", function(){

        $(".exp-search-input").trigger("submit");

    });

    $('.new-search').on('click', function(){

        if( Foundation.MediaQuery.current == 'medium' || Foundation.MediaQuery.current == 'large' ) {

            $('.search-desktop').animate({"margin-left": '-240'});
            $('.search-input').animate({width: '240'});
            $('.search-results').animate({width: '240'});

            // $('body').on('focusout', function() {
            //     $('.search-desktop').animate({"margin-left": '0'});
            //     $('.search-input').animate({width: '0'});
            // });

        } else {

            $('.search-desktop').animate({"margin-left": '-350'});
            $('.search-input').animate({width: '350'});
            $('.search-results').animate({width: '350'});

            $('body').on('focusout', function() {
                $('.search-desktop').animate({"margin-left": '-240'});
                $('.search-input').animate({width: '240'});
            });

        }

    });

    // Desktop search
    $('.cust-header-search .cust-search img').on('click', function(){
        $('.desktop-search-container').slideToggle();
        $('.desktop-search-container').find('.exp-search-input').trigger( "focus" );
        return false;
    });


    $('.master-bar__wrapper').slick({

        dots: false,
        arrows: false,
        autoplay: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        speed: 200,
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    fade: true,
                    speed: 200,
                    slidesToScroll: 1
                }

            },
            {
                breakpoint: 768,
                settings: {
                    destroy: true
                }
            }

        ]

    });

    $('.home-threesmallboxes').slick({
        dots: false,
        arrows: false,
        autoplay: true,
        centerMode: true,
        slidesToShow: 3,
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 1
                }

            },
            {
                breakpoint: 768,
                settings: {
                    centerMode: false,
                    centerPadding: '0px',
                    destroy: true
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    centerPadding: '0px'
                }
            },
            {
                breakpoint: 1440,
                settings: {
                    centerPadding: '0px'
                }
            }
        ]
    });

    // Scroll to top on mobile when opening the menu
    $(".mobilemenu-toggle").on("click", function(){

        // masterBar.toggleClass("menuToggled fixed");
        $("html, body").animate({ scrollTop: 0 }, "fast");
        $(".mobile-search-icon").toggleClass("notindexed");
        return false;

    });

});
